import { Input } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.black1};
  padding: 24px;
  border-radius: 8px;
`;

export const StatusFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  .ant-form-item {
    margin-bottom: 0;
  }
`;

export const StatusSectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  & .ant-btn {
    font-size: 14px !important;
    font-weight: 500 !important;
    line-height: 20px !important;
    color: ${({ theme }) => theme.colors.black8};
  }
`;

export const FormFieldLabel = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.black9};
`;

export const ObservationsTextArea = styled(Input.TextArea)`
  border-radius: 4px;
  resize: none;
  font-size: 14px;

  &.ant-input {
    border: 1px solid ${({ theme }) => theme.colors.black3};

    &:hover,
    &:focus {
      border-color: ${({ theme }) => theme.colors.black3};
      box-shadow: none;
    }
  }
`;

export const ObservationsCharacterCount = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.black6};
  text-align: right;
  margin-top: 4px;
`;
